import { stringify } from 'querystring';
import { useModel } from '../../use';
import { network, generators } from '../../../utils';
import api from '../../../config/api';
import message from '../message';
import { custom } from '../../../service/common';
import {
  customCodePopState,
  customCodePopEffects,
} from '../customCodePop/customCodeModel';
/**
 * store
 */
const initialState = {
  modalVisible: false, // 图纸弹框
  record: {}, // 图纸弹框信息
  collectVisible: false, // 收藏当前行
  customVisible: false, // 自定义当前行
  stockVisible: false, // 拆分标识当前行
  upStockVisible: false, // 上边框中的拆分标识当前行
  cartItemQtyVisible: false, // 需求数量当前行
  isOperation: false, // 标识是否为操作,如果是收藏或自定义操作,则为true,其他为false
  isNew: false,
  key: undefined,
  collection: '默认收藏夹',
  customCode: '',
  ...customCodePopState,
  stockCode: null,
  stockCodeList: [],
  imgsModalVisible: false, // 图片弹框
  imgs: [], // 图片地址信息
  sysList: [],
  activityVisible: false,
  qualityVisible: false,
  currentUnPackFlag: false, // 当前操作行是否可拆散
};
const updateState = (state, payload) => {
  return { ...state, ...payload };
};

const effects = {
  ...customCodePopEffects,
  updateCustomCodeItem: async ({ payload }) => {
    const response = await custom(payload);
    if (response.success) {
      const result = generators.generatorObject(response.data);
      if (!result.success) {
        message.error(result.message);
        return false;
      }
      message.success('修改成功');
      return true;
    }
    return false;
  },
  // 获取拆分标识编码
  queryStockCode: async ({ payload: params, dispatch }) => {
    const response = await network({
      url: api.cart.querySsCode,
      method: 'get',
    });
    if (response.success) {
      if (!response.data.success) {
        message.error(response.data.message);
        return;
      }
      dispatch('updateState')({
        stockCode: response.data.data,
        stockCodeList: [response.data.data],
        isNew: true,
      });
    }
  },
  saveStock: async ({ payload: params }) => {
    const response = await network({
      url: api.cart.editSsCode,
      method: 'post',
      data: params,
    });
    if (!response.success) message.error(response.data.message);
    return !!response.data.success;
  },
  // 查询列表单行图片明细
  queryListImgs: async ({ payload, dispatch, state }) => {
    const { record, searchValue } = payload;
    const {
      ibsrp7: [ibsrp7] = [],
      CAT_32: [CAT_32] = [],
      CAT_35: [CAT_35] = [],
      CAT_37: [CAT_37] = [],
    } = searchValue;
    const response = await network({
      url: api.search.commodityPic,
      method: 'get',
      params: {
        teitm: record.imitm,
        scatId: record.scatId,
        pcatId: record.pcatId,
        ibsrp7: ibsrp7 || record.ibsrp7,
        ibsrp3Dl01: CAT_32 || record.ibsrp3Dl01,
        ibsrp5Dl01: CAT_35 || record.ibsrp5Dl01,
        ibsrp9Dl01: CAT_37 || record.ibsrp9Dl01,
      },
    });
    if (response.success) {
      dispatch('updateState')({ imgs: response.data.data.icoSrcs });
    }
  },
  getSysConfig: async ({ payload, dispatch, state }) => {
    const response = await network({
      url: api.finance.introductionList,
      method: 'post',
      data: ['mcuActivityDesc', 'disActivityDesc', 'fixedActivityDesc', 'specialActivityDesc'],
    });
    if (response.success) {
      dispatch('updateState')({ sysList: response.data });
    } else {
      message.error(response.data.message);
      return;
    }
  },
};

const useSearchTableModel = () =>
  useModel({
    state: initialState,
    reducers: { updateState },
    effects,
  });
export default useSearchTableModel;
